import React, { useState } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import { useTranslation } from "react-i18next";
import style from "./BreakpointsDevices.module.css";
import { GetStateFromData } from "../../../CustomHooks/CustomHooks";

export default function BreakpointsDevices(props) {
  const { t } = useTranslation();

  const [selectIndex, setSelectIndex] = useState();

  const contexts = GetStateFromData(props.containerId);
  const { updateJson, setWidthOfCanvas } = contexts.contexts;
  const { updatedComponentInFormState } = updateJson;

  const deviceJson = [
    { deviceName: "Laptop Medium", deviceWidth: "1366" },
    { deviceName: "Laptop Small", deviceWidth: "1240" },
    { deviceName: "iPad", deviceWidth: "768" },
    { deviceName: "iPad Pro", deviceWidth: "980" },
    { deviceName: "iPhone 6/7/8", deviceWidth: "522" },
    { deviceName: "Galaxy S5", deviceWidth: "430" }
  ];

  if (props.formdata?.style?.["CurrentDevice"] === undefined) {
    if (props.formdata?.style) {
      props.formdata.style["CurrentDevice"] = {};
    }
  }

  function selectDevice(index) {
    props.formdata.style["CurrentDevice"] = {
      DeviceWidth: parseInt(deviceJson[index].deviceWidth)
    };
    setWidthOfCanvas(parseInt(deviceJson[index].deviceWidth));
    updatedComponentInFormState();
    setSelectIndex(index);
    // selectedDevice={props?.selectedDevice}
    if(props?.setSelectedDevice){
      props?.setSelectedDevice(deviceJson[index].deviceWidth);
    }

  }

  return (
    <div tabIndex={0} className={style.longMenuWrapper}>
      {deviceJson.map((option, index) => (
        <MenuItem
          key={option.deviceName}
          tabIndex="0"
          disableGutters={true}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              selectDevice(index);
            }
          }}
          className={index === selectIndex ? style.deviceContentAfterSelected : style.deviceContent}
          onClick={() => selectDevice(index)}
        >
          <input type="radio" name="device_Breakpoints" checked={option?.deviceWidth === props?.selectedDevice} className={style.inputRadio} />
          <span className={style.deviceWidth}>
            {option.deviceWidth}&nbsp; - &nbsp;{t(option.deviceName)}
          </span>
        </MenuItem>
      ))}
    </div>
  );
}
